import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import FileOverviewTable from "../utils/FileOverviewTable";

function FileHistory(props) {
  const { JobType, fileList, hideErrRecords, loadErroredData, jobHistory_id, jobId } = props;

  const [searchTerm, setSearchTerm] = useState("");

  const $DataSourceList = useMemo(
    () => (JobType === 1 ? [...new Set(fileList.map((file) => file.SOURCE))] : []),
    [JobType, fileList]
  );

  const $filteredData = useMemo(() => {
    const search = searchTerm?.toLowerCase();
    return search
      ? fileList.filter(
          ({ FILEPATH, SOURCE, status }) =>
            FILEPATH?.toLowerCase().includes(search) ||
            SOURCE?.toLowerCase().includes(search) ||
            status?.toLowerCase().includes(search)
        )
      : fileList;
  }, [fileList, searchTerm]);

  return (
    <Box>
      <TextField
        variant="standard"
        placeholder="Search"
        margin="normal"
        value={searchTerm}
        id="outlined-size-small"
        InputProps={{
          startAdornment: <SearchIcon color="primary" sx={{ marginRight: "5px" }} />,
          ...(searchTerm && {
            endAdornment: (
              <IconButton
                onClick={() => {
                  setSearchTerm("");
                }}
                size="small"
              >
                <ClearIcon color="primary" />
              </IconButton>
            ),
          }),
        }}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mr: "5px", pb: "16px", width: { xs: "100%", sm: "37.5%" } }}
      />
      <FileOverviewTable
        JobType={JobType}
        data={$filteredData}
        hideErrRecords={hideErrRecords}
        DataSources={$DataSourceList}
        loadErroredData={loadErroredData}
        jobHistoryId={jobHistory_id}
        jobId={jobId}
      />
    </Box>
  );
}

FileHistory.propTypes = {
  JobType: PropTypes.number.isRequired,
  fileList: PropTypes.array.isRequired,
  loadErroredData: PropTypes.bool.isRequired,
  jobHistory_id: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired,
};

export default FileHistory;
